import React, { useRef, useEffect } from 'react';
import { Table, Badge } from 'reactstrap';
import PerfectScrollbar from 'perfect-scrollbar';

/**
 * Tabla de datos reutilizable
 * @param {Array} columns - Array de objetos con { key, label, render? }
 * @param {Array} data - Array de datos a mostrar
 * @param {Function} onRowClick - Función a ejecutar al hacer click en una fila
 * @param {Boolean} loading - Indica si está cargando
 */
function DataTable({ columns, data, onRowClick, loading = false }) {
  const tableRef = useRef(null);
  const psRef = useRef(null);

  // Inicializar PerfectScrollbar cuando la tabla se renderiza
  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1 && tableRef.current && !loading && data && data.length > 0) {
      // Pequeño delay para asegurar que el DOM esté completamente renderizado
      const timer = setTimeout(() => {
        if (tableRef.current && !psRef.current) {
          try {
            psRef.current = new PerfectScrollbar(tableRef.current, {
              suppressScrollX: false,
              suppressScrollY: false,
            });
          } catch (error) {
          }
        }
      }, 100);

      return () => {
        clearTimeout(timer);
        if (psRef.current) {
          try {
            psRef.current.destroy();
            psRef.current = null;
          } catch (error) {
          }
        }
      };
    }
  }, [data, loading]);

  // Actualizar PerfectScrollbar cuando cambian los datos
  useEffect(() => {
    if (psRef.current && tableRef.current) {
      setTimeout(() => {
        psRef.current.update();
      }, 100);
    }
  }, [data]);

  if (loading) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Cargando datos...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No hay datos para mostrar</p>
      </div>
    );
  }

  return (
    <div
      style={{ overflowX: 'auto', overflowY: 'hidden', WebkitOverflowScrolling: 'touch', width: '100%' }}
      ref={tableRef}
    >
      <Table className="tablesorter" style={{ minWidth: '600px' }}>
        <thead className="text-primary">
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={row.id || index}
              onClick={() => onRowClick && onRowClick(row)}
              style={onRowClick ? { cursor: 'pointer' } : {}}
            >
              {columns.map((column) => {
                const accessor = column.accessor || column.key;
                // Intentar acceder tanto con el accessor como con el key, y también en camelCase
                const value = row[accessor] || row[column.key] || 
                              (accessor && row[accessor.charAt(0).toLowerCase() + accessor.slice(1)]);
                return (
                  <td key={column.key}>
                    {column.render
                      ? column.render(value, row)
                      : value !== null && value !== undefined && value !== ''
                      ? String(value)
                      : '-'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default DataTable;

